var map = {
	".": "2uFj",
	"./": "2uFj",
	"./api": "2hMI",
	"./api.js": "2hMI",
	"./dev": "7G+W",
	"./dev.js": "7G+W",
	"./env": "uaSg",
	"./env.js": "uaSg",
	"./index": "2uFj",
	"./index.js": "2uFj",
	"./prod": "2CaA",
	"./prod.js": "2CaA",
	"./test": "zzii",
	"./test.js": "zzii",
	"./uat": "MXfq",
	"./uat.js": "MXfq"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Vy3i";


//////////////////
// WEBPACK FOOTER
// ./src/config ^.*$
// module id = Vy3i
// module chunks = 23